import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { DocsList } from 'apps/auth/components/common/components/DocsList/DocsList';
import { DocsListItem } from 'apps/auth/components/common/components/DocsList/DocsListItem';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const NewClientSideDisclaimer = ({ onButtonClick, onCloseClick, detailsClick }) => {
    const {
        newDisclaimerHeader,
        newDisclaimerTitleFirst,
        newDisclaimerTitleFirstText,
        newDisclaimerTitleSecondHeader,
        newDisclaimerTitleSecondSubheader,
        newDisclaimerTitleThirdHeader,
        newDisclaimerTitleThirdSubheader,
        newDisclaimerLinkTitle,
        submitDisclaimer,
        notificationNameTo,
    } = usePageMessages();

    const textStyle = { color: 'secondary' };

    return (
        <ModalComponent onCloseIconClick={onCloseClick} hasBottomPanel>
            <HeaderPanel title={resolveArguments(newDisclaimerHeader, [notificationNameTo])} />
            <DocsList>
                {newDisclaimerTitleFirst && (
                    <DocsListItem title={newDisclaimerTitleFirst}>
                        <Row indent="adaptive-16-24">{MarkdownService.splitByParagraph(newDisclaimerTitleFirstText, [], textStyle)}</Row>
                        {detailsClick && (
                            <Button
                                caption={newDisclaimerLinkTitle}
                                onClick={() => {
                                    detailsClick();
                                }}
                                type="button"
                                variant="row"
                                size="tight"
                                negativeMargin
                            />
                        )}
                    </DocsListItem>
                )}
                {newDisclaimerTitleSecondHeader && (
                    <DocsListItem title={newDisclaimerTitleSecondHeader}>
                        {MarkdownService.splitByParagraph(newDisclaimerTitleSecondSubheader, [], textStyle)}
                    </DocsListItem>
                )}
                {newDisclaimerTitleThirdHeader && (
                    <DocsListItem title={newDisclaimerTitleThirdHeader}>
                        {MarkdownService.splitByParagraph(newDisclaimerTitleThirdSubheader, [], textStyle)}
                    </DocsListItem>
                )}
            </DocsList>
            <FixedBottomPanel isRightAligned>
                <Button type="button" raised={true} onClick={onButtonClick} caption={submitDisclaimer} />
            </FixedBottomPanel>
        </ModalComponent>
    );
};

export default NewClientSideDisclaimer;
